export default __webpack_public_path__ + "static/media/2_Intro.5451ee86.mp4";